import React, { Fragment, useContext, useEffect } from "react"
import { useState } from "react";
import Contexto from "../comun/Contexto";
import Tabla from "../comun/Tabla";
import { traerRespuestas } from "./Resultados";

const estilo14 = {width:"14%"};
const estilo16 = {width:"16%"};
const columnas = [    
    {style: estilo14, nombre:"Centro poblado", dataKey:"NOMBRE_CENTRO_POBLADO"},
    {style: estilo14, nombre:"Municipio", dataKey:"MUNICIPIO"}, 
    {style: estilo14, nombre:"Intensidad", dataKey:"INT_RED", tipo:"numerico"},
    {style: estilo14, nombre:"No. formularios", dataKey:"CONTEO", tipo:"numerico"},
    {style: estilo14, nombre:"Distancia al hipocentro (km)", dataKey:"DIST", tipo:"numerico"},
    {style: estilo14, nombre:"Latitud", dataKey:"LATITUD", tipo:"numerico"}, 
    {style: estilo16, nombre:"Longitud", dataKey:"LONGITUD", tipo:"numerico"}
];

const ResRespuestas = ({idSismo})=> {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    /* Estado */
    const [respuestas, setRespuestas] = useState([]);

    useEffect(()=> {
        traerRespuestas(urlBaseRest, idSismo, setRespuestas);       
    }, []);    

    return (
        <Fragment>
            <div className="ResultadosRecuadro">
                En esta tabla se incluyen los municipios para los cuales se reportaron efectos y se evaluó su intensidad. Se presenta el número de formularios que se diligenciaron por municipio, sus coordenadas y la distancia al hipocentro (punto en profundidad donde se origina el sismo)
            </div>
            

            <Tabla columnas ={columnas } datosIni={respuestas}/>
            

            <a href={urlBaseRest+"tabla_respuestas_excel/" + idSismo} className="TablaRespuestasLinkExcel">
                Descargar XLS
            </a>
            <br/>
            &nbsp;
        </Fragment>
    )
}

export default ResRespuestas;